(ns reagent-material-ui.icons.delete-icon
  "Imports @material-ui/icons/Delete as a Reagent component."
  (:require-macros [reagent-material-ui.macro :refer [e]])
  (:require [react :as react]
            [reagent-material-ui.util :refer [create-svg-icon]]))

(def delete (create-svg-icon (e "path" #js {"d" "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"})
                             "Delete"))
